import React from "react";

const ChiropodyPodiatryCheckListContent = {
  checklistText: (
    <React.Fragment>
      <p>
        Chiropody and podiatry cash benefit is not available on all plans.
        Please check your handbook to see if you have cover.
      </p>
      <p>Before you start, please have the following ready:</p>
    </React.Fragment>
  ),
  checklist: ["Invoices, receipts or bills for your claim"],
  checklistSLA:
    "Once you've submitted your documents, please allow up to 10 working days for us to review them.",
  infoBoxIconClass: "icon-help-outline"
};

const ChiropodyPodiatry = {
  HOL: {
    ...ChiropodyPodiatryCheckListContent,
    checklistText: (
      <React.Fragment>
        <p>
          Chiropody and podiatry cash benefit is not available on all policies.
          Please check your handbook to see if you have cover.
        </p>
        <p>Before you start, please have the following ready:</p>
      </React.Fragment>
    )
  },
  Any: ChiropodyPodiatryCheckListContent
};

export default ChiropodyPodiatry;
